import { Col, Row } from "antd";
import { ReactNode, useEffect, useState } from "react";
import Sidebar from "../components/sidebar/Sidebar";
import MainNavbar from "../components/navbar/MainNavbar";

// Define type for props
type LayoutProp = {
  layoutIdentifier: string | null; // Ensure layoutIdentifier is of type PageType
  children?: ReactNode; // Ensure children prop is of type ReactNode
};

function LayoutWrapper({ layoutIdentifier, children }: LayoutProp) {
  const [mobileSideBar, setMobileSideBar] = useState<boolean>(false);

  useEffect(() => {
    setMobileSideBar(false);
  }, [children]);

  switch (layoutIdentifier) {
    case "TWO_COLUMN":
      return (
        <Row>
          <Col lg={4} xs={mobileSideBar ? 24 : 0} sm={mobileSideBar ? 24 : 0}>
            <Sidebar />
          </Col>
          <Col
            lg={20}
            xs={mobileSideBar ? 0 : 24}
            sm={mobileSideBar ? 0 : 24}
            className="min-h-[100vh]"
          >
            <MainNavbar
              setMobileSideBar={setMobileSideBar}
              mobileSideBar={mobileSideBar}
            />
            <div className="lg:p-3">{children}</div>
          </Col>
        </Row>
      );
    default:
      return <div>{children}</div>;
  }
}

export default LayoutWrapper;
